import Cookies from 'js-cookie'

const CHANNEL_NAME = 'zd-auth'
const TOKEN_COOKIE = 'token'
const DEFAULT_INTERVAL = 2000

let channel = null

function getChannel() {
  if (channel !== null) return channel
  channel = typeof BroadcastChannel !== 'undefined' ? new BroadcastChannel(CHANNEL_NAME) : false
  return channel
}

function cookieDomains() {
  const domains = [undefined]
  const configured = window.config?.cookie_domain
  if (configured) domains.push(configured, `.${configured}`)

  const labels = window.location.hostname.split('.')
  while (labels.length > 1) {
    const domain = labels.join('.')
    domains.push(domain, `.${domain}`)
    labels.shift()
  }

  return domains
}

export function clearCookie(name) {
  cookieDomains().forEach((domain) => {
    Cookies.remove(name, domain ? { domain, path: '/' } : { path: '/' })
  })
}

export function clearAuthCookie() {
  clearCookie(TOKEN_COOKIE)
}

export function broadcastLogout() {
  const ch = getChannel()
  if (!ch) return
  try {
    ch.postMessage({ type: 'logout' })
  } catch (error) {
    console.error(error)
  }
}

export function startAuthWatcher({ isLoggedIn, onForeignLogout, intervalMs = DEFAULT_INTERVAL }) {
  let handled = false

  function trigger() {
    if (handled || !isLoggedIn()) return
    handled = true
    onForeignLogout()
  }

  function checkCookie() {
    if (isLoggedIn() && !Cookies.get(TOKEN_COOKIE)) trigger()
  }

  function onMessage(event) {
    if (event && event.data && event.data.type === 'logout') trigger()
  }

  const ch = getChannel()
  if (ch) {
    ch.addEventListener('message', onMessage)
  }

  function onVisibilityChange() {
    if (document.visibilityState === 'visible') checkCookie()
  }

  document.addEventListener('visibilitychange', onVisibilityChange)
  window.addEventListener('focus', checkCookie)
  const timer = window.setInterval(checkCookie, intervalMs)

  return function stop() {
    if (ch) ch.removeEventListener('message', onMessage)
    document.removeEventListener('visibilitychange', onVisibilityChange)
    window.removeEventListener('focus', checkCookie)
    window.clearInterval(timer)
  }
}
